import { cloneDeep } from 'lodash';
import { Framework, trackConfig } from '@/framework';
import { LayerType } from '@/version-types';
import { StageOperateImpl } from '../stage-operate';
import { historyQuickResizeOperate } from '../type';

/**
 * 长画布舞台快速调整
 */
export class QuickResizeOperate extends Framework {
    /**
     * 写入操作历史记录
     *
     * @param originIndex - 原序号
     * @param oldHeight - 旧的高度
     * @param newHeight - 新的高度
     */
    write(originIndex: number, oldHeight: number, newHeight: number) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        const extensions = this.framework.service.registration
            .getInstance<StageOperateImpl>('StageOperate')
            .collectHistoryExtensions({
                operation: 'resize',
                originIndex,
                oldHeight,
                newHeight,
            });
        this.framework.service.history.write({
            type: historyQuickResizeOperate,
            data: {
                originIndex,
                oldHeight,
                newHeight,
                extensions,
            },
            trackFunc: trackConfig[LayerType.BACKGROUND_LAYER]?.resize,
        });
        return this;
    }

    /** 同步快速调整 */
    send(originIndex: number, oldHeight: number, newHeight: number, isStart: boolean, isEnd: boolean) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        this.framework.service.history.realEdit.send(historyQuickResizeOperate, {
            originIndex,
            oldHeight,
            newHeight,
            isStart,
            isEnd,
        });
        return this;
    }

    /**
     * 快速调整长图高
     *
     * @param originIndex - 原序号
     * @param height - 高度
     */
    doResize(originIndex: number, height: number) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        const backgroundLayer = cloneDeep(this.framework.service.frame.getBackgroundLayer(originIndex));
        if (backgroundLayer) {
            this.framework.service.behavior.get(backgroundLayer)?.adjustHeight?.(backgroundLayer, height);
            this.framework.service.flatLayer.set(
                backgroundLayer.id,
                { ...backgroundLayer },
                { onlyUpdateBaseInfo: false },
            );
        }
        // this.framework.service.edgelessCanvas.renderAll();
        // this.framework.service.frame.rerender(originIndex);
        return this;
    }
}
